import React from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from 'inside-out/components/shared/icons/arrowIcon';
import { Link } from 'inside-out/components/shared/link';
import { linkStyle } from './styles';

// This is required because in the CMS we don't want to render real working links.

export const ArrowLink = ({ to, href, children, onClick }) => {
	if (href) {
		return (
			<a
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				className={linkStyle}
				data-component="ArrowLink"
			>
				{children} <ArrowIcon fill="inherit" />
			</a>
		);
	}

	return (
		<Link to={to} onClick={onClick} className={linkStyle} data-component="ArrowLink">
			{children} <ArrowIcon fill="inherit" />
		</Link>
	);
};

ArrowLink.propTypes = {
	to: PropTypes.string,
	href: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/shared/arrowLink/component.js